<template>
	<inertia-head title="Payout Request" />
	<div class="bg-primary">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Payout Request</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Welcome to TRC Admin Dashboard
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div class="row">
			<div class="col-lg-12">
				<div class="block block-rounded shadow mb-1">
					<div class="block-content">
						<form @submit.prevent="searchRecord(0)">
							<div class="row">
								<div class="col-md-3">
									<div class="form-group mb-4">
										<flat-pickr
											v-model="date_start"
											id="date_start"
											class="form-select"
											placeholder="Select start date"
										/>
									</div>
								</div>
								<div class="col-md-3">
									<div class="form-group mb-4">
										<flat-pickr
											v-model="date_end"
											id="date_end"
											class="form-select"
											placeholder="Select end date"
										/>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col space-x-1 mb-4">
									<div class="input-group">
										<div class="input-group-prepend"><span class="input-group-text">Filter By Status</span></div>
										<select v-model="status" id="status" name="status" class="form-select">
											<option value="">ALL</option>
						                    <option value="PR">Processing</option>
						                    <option value="I">Invalid</option>
						                    <option value="P">Pending</option>
						                    <option value="S">Successfully completed</option>
						                    <option value="H">On hold</option>
						                    <option value="G">In Progress</option>
						                    <option value="V">Voided</option>
						                    <option value="F">Failed</option>
										</select>
									</div>
								</div>
								<div class="col space-x-1 mb-4">
									<input v-model="search" type="text" id="search" name="search" class="form-control" placeholder="Enter Search Info" />
								</div>
								<div class="col space-x-1 mb-4">
									<button type="submit" class="btn btn-alt-primary">
										<i class="fa fa-search me-1"></i>Display
									</button>
									<button
										@click="searchRecord(1)"
										type="button"
										class="btn btn-alt-secondary"
									>
										<i class="fa fa-retweet me-1"></i>Reset
									</button>
								</div>
							</div>
						</form>
					</div>
				</div>

				<div class="block block-rounded">
					<div class="block-content block-content-full">
						<div class="table-responsive">
							<table class="table table-striped table-borderless table-vcenter">
								<thead class="border-bottom">
									<tr>
										<th>STATUS</th>
										<th>USERNAME</th>
										<th>METHOD</th>
										<th>ACCOUNT INFO</th>
										<th>EMAIL</th>
										<th>MOBILE</th>
										<th>TIN</th>
										<th>REQUESTED</th>
										<th>TAX</th>
										<th>PF</th>
										<th>TOTAL</th>
										<th>TRANS DATE</th>
										<th>TRANS NUM</th>
										<th>REF NUM</th>
										<th>DATE POSTED</th>
										<th>SETTLE DATE</th>
										<th>REMARKS</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(member,m_index) in payoutRequest.data" :key="member.counter">
										<td nowrap="">
											<span>{{member.status_format}}</span>
											<div>
												<button v-if="member.status=='PR' && member.posted_by==null && ['ian','thibz'].includes($page.props.user.fname)" @click="deletePayout(m_index)" type="button" class="btn btn-alt-danger btn-sm me-1"><i class="fa fa-trash me-1"></i>Delete</button>
												<button v-if="member.posted_by!=null && ['ian','thibz'].includes($page.props.user.fname)" @click="viewPayoutInfo(m_index)" type="button" class="btn btn-alt-info btn-sm"><i class="fa fa-check-circle me-1" ></i> Check Status</button>
											</div>
										</td>
										<td>{{ member.username }}</td>
										<td>
											{{ member.method }}
											<div>({{ member.bankbranch }})</div>
										</td>
										<td>
											{{ member.account_name }}
											<div>#: {{ member.account_number }}</div>
										</td>
										<td>{{ member.email }}</td>
										<td>{{ member.mobile_number }}</td>
										<td>{{ member.tin_number }}</td>
										<td>{{ member.qualified }}</td>
										<td>{{ member.tax }}</td>
										<td>{{ member.pf }}</td>
										<td>{{ member.total }}</td>
										<td>{{ member.trans_date }}</td>
										<td>{{ member.trans_num }}</td>
										<td>
											<button v-if="member.posted_by==null && ['ian','thibz'].includes($page.props.user.fname)" @click="proceedToDragonpay(member.trans_num)" type="button" class="btn btn-alt-primary btn-sm">Proceed to Dragonpay</button>
											<span v-else>{{ member.dp_refno }}</span>
										</td>
										<td>{{ member.date_posted }}</td>
										<td>{{ member.settleDate }}</td>
										<td>{{ member.remarks }}</td>
									</tr>
									<tr v-if="payoutRequest.data.length<=0">
										<td colspan="19">
											<p class="m-0 fw-bold h5 text-center text-danger">No Record Found</p>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<pagination :collections="payoutRequest" />
					</div>
				</div>

			</div>
		</div>
	</div>

	<payout-info-modal
		ref="viewPayoutInfoModal"
	></payout-info-modal>


	<modal ref="deletePayoutModal">
		<template #title>DELETE CONFIRMATION</template>
		<template #body>
			<div class="text-center">
                <p class="h6">
                    Are you sure, you want to delete this record?
                </p>
            </div>
		</template>
		<template #footer>
			<button type="button" @click="confirmDeletePayout()" :disabled="formDelete.processing" class="btn btn-alt-primary btn-sm">
				<i v-if="!formDelete.processing" class="fa fa-check-circle me-1"></i>
				<span v-else>
					<div class="spinner-border spinner-border-sm text-dark" role="status" >
						<span class="sr-only mr-1">Please wait...</span>
					</div>
				</span>
				YES
			</button>
            <button @click="deletePayoutModal.toggleModal" type="button" :disabled="formDelete.processing" id="btnDeleteClose" class="btn btn-alt-danger btn-sm"><i class="fa fa-times-circle me-1"></i>NO</button>
		</template>
	</modal>

</template>

<script>
import { useForm } from '@inertiajs/inertia-vue3'
import { onMounted, ref, reactive, watch } from 'vue'
import AuthLayout from '../../../Layouts/AuthLayout'
import { Inertia } from '@inertiajs/inertia';
import PayoutInfoModal from '../../../Components/Admin/AffiliateProgram/PayoutInfoModal'

export default {
	props:{
		flash 			: Object,
		payoutRequest 	: Object,
		api_response  	: Object,
		filters 		: Object
	},
	layout: AuthLayout,
	components:{PayoutInfoModal},
	setup(props) {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})

		const status 		= ref(props.filters.status??'');
		const search 		= ref(props.filters.search??'');
		const date_start 	= ref(props.filters.date_start??'');
		const date_end 		= ref(props.filters.date_end??'');

		const formDelete 		= useForm({
									counter  	: 0,
									trans_num 	: '',
								});

		const selectedPayout 	= reactive({});

		const deletePayoutModal 	= ref(null);
		const viewPayoutInfoModal 	= ref(null);

		const searchRecord = (_is_reset) => {

								if(_is_reset==1)
								{
									status.value 		= "";
									search.value 		= "";
									date_start.value 	= "";
									date_end.value 		= "";
								}

								Inertia.get(
									route('admin.affiliate-program.payout-request'),
									{
										status 		: status.value,
										search 		: search.value,
										date_start	: date_start.value,
										date_end 	: date_end.value
									},
									{
										preserveState: true,
										preserveScroll: true,
										only: ['payoutRequest','api_response','filters']
									}
								)
							}

		const deletePayout = (_index)=>{
			Object.assign(selectedPayout,props.payoutRequest.data[_index]);
			deletePayoutModal.value.toggleModal();
		}

		const viewPayoutInfo = (index)=>{
							
							viewPayoutInfoModal.value.setPayoutInfo(props.payoutRequest.data[index]);
							viewPayoutInfoModal.value.toggleModal();
						}

		const confirmDeletePayout = ()=>{
			let data = selectedPayout;

			formDelete.counter 		= data.counter;
			formDelete.trans_num 	= data.trans_num;

			formDelete.delete('payout-request/'+data.counter,{
				preserveState: true,
				preserveScroll: true,
				only: ['payoutRequest','api_response','filters','flash'],
				onSuccess: ()=>{
					deletePayoutModal.value.toggleModal();
				}
			})
		}

		const proceedToDragonpay = (trans_num)=>{

									Inertia.get('/api/admin/affiliate-program/send/payout-request/'+trans_num,
										{
											preserveState: true,
											preserveScroll: true,
											only: ['payoutRequest','api_response','filters','flash'],
											onSuccess: ()=>{

											}
										}
									)

									// axios.get('/api/admin/affiliate-program/send/payout-request/'+trans_number)
									//    .then(res => {
									//       if(res.result.data=="success")
									//       {
									//       	console.log("Success");
									//       }else
									//       {
									//       	console.log("Failed");
									//       }
									//    })

								}

		return{
			status,
			search,
			date_start,
			date_end,
			formDelete,
			selectedPayout,
			viewPayoutInfo,
			deletePayoutModal,
			viewPayoutInfoModal,
			deletePayout,
			confirmDeletePayout,
			searchRecord,
			proceedToDragonpay
		}

	}
}
</script>
